import { createQuery } from "react-query-kit";

import type { ICommentsEndpoint } from "./types";

import type {
  AxiosError,
  IApiResponse,
  IAxiosFn,
  IPaginationParams,
  ISearchParams,
  IWithFilters,
  IWithPagination,
  IWithStats,
} from "@api/types";
import { axiosClient } from "@/api/clients";

const key = "comments";

type IResponse = IApiResponse<
  IWithFilters<IWithStats<IWithPagination<ICommentsEndpoint>>>
>;
export type IVariables = IPaginationParams & ISearchParams;

// TODO add table filters
const getComments: IAxiosFn<IVariables, IResponse> = async (params, signal) => {
  const { data } = await axiosClient.get("/comments", {
    params,
    signal,
  });

  return data;
};

export const useComments = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getComments(variables, signal),
});
